var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ApiService } from '../../../services/api.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
var SellerDetailComponent = (function () {
    function SellerDetailComponent(activeModal, formBuilder, apiService) {
        this.activeModal = activeModal;
        this.formBuilder = formBuilder;
        this.apiService = apiService;
        this.username = localStorage.getItem('username');
        this.isHeadOffice = false;
        this.errorMessage = null;
    }
    SellerDetailComponent.prototype.ngOnInit = function () {
        this.logo = this.sellerDetail ? this.sellerDetail.logo : null;
        this.sellerForm = this.formBuilder.group({
            nameTH: [this.sellerDetail ? this.sellerDetail.name_th : null, Validators.required],
            nameEN: [this.sellerDetail ? this.sellerDetail.name_en : null],
            taxID: [this.sellerDetail ? this.sellerDetail.tax_id : null, Validators.required],
            branchCode: [this.sellerDetail ? this.sellerDetail.branch_code : null, Validators.required],
            branchName: [this.sellerDetail ? this.sellerDetail.branch_name : null, Validators.required],
            addressTH: [this.sellerDetail ? this.sellerDetail.address_th : null, Validators.required],
            addressEN: [this.sellerDetail ? this.sellerDetail.address_en : null],
            postalCode: [this.sellerDetail ? this.sellerDetail.post_code : null, Validators.required]
        });
        if (this.sellerDetail && this.sellerDetail.branch_code === '00000') {
            this.isHeadOffice = true;
            this.setHeadOffice();
        }
    };
    SellerDetailComponent.prototype.setHeadOffice = function () {
        if (this.isHeadOffice) {
            this.branchCode.setValue('00000');
            this.branchName.setValue('HQ');
            this.branchCode.disable();
            this.branchName.disable();
        }
        else {
            this.branchCode.setValue(this.sellerDetail ? this.sellerDetail.branch_code : null);
            this.branchName.setValue(this.sellerDetail ? this.sellerDetail.branch_name : null);
            this.branchCode.enable();
            this.branchName.enable();
        }
    };
    SellerDetailComponent.prototype.fileToBase64 = function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () { resolve(reader.result); };
            reader.onerror = function () { reject(new Error('Unable to read')); };
        });
    };
    SellerDetailComponent.prototype.onLogoChange = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var file, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        file = event.target.files[0];
                        _a = this;
                        return [4 /*yield*/, this.fileToBase64(file)];
                    case 1:
                        _a.logo = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SellerDetailComponent.prototype.submit = function () {
        var _this = this;
        this.errorMessage = null;
        if (this.sellerForm.valid) {
            var data_1 = {
                name_th: this.nameTH.value || '',
                name_en: this.nameEN.value || '',
                tax_id: this.taxID.value || '',
                branch_code: this.branchCode.value || '',
                branch_name: this.branchName.value || '',
                address_th: this.addressTH.value || '',
                address_en: this.addressEN.value || '',
                post_code: this.postalCode.value || '',
                logo: this.logo || ''
            };
            // get API by operation
            var api = this.sellerDetail ? this.apiService.updateSellerBranch(this.sellerDetail.id, data_1) : this.apiService.createSellerBranch(data_1);
            api.pipe(finalize(function () {
                _this.sellerDetail ? _this.sniff('UPDATE_SELLER', data_1.name_th) : _this.sniff('CREATE_SELLER', data_1.name_th);
            })).subscribe(function () {
                _this.activeModal.close('Submit');
            }, function (err) {
                console.log(err);
                _this.errorMessage = err.error.detail;
            });
        }
    };
    SellerDetailComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'MANAGE_SELLER',
            target: target
        };
        this.apiService.sniff(data).subscribe();
    };
    Object.defineProperty(SellerDetailComponent.prototype, "nameTH", {
        get: function () {
            return this.sellerForm.get('nameTH');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerDetailComponent.prototype, "nameEN", {
        get: function () {
            return this.sellerForm.get('nameEN');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerDetailComponent.prototype, "taxID", {
        get: function () {
            return this.sellerForm.get('taxID');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerDetailComponent.prototype, "branchCode", {
        get: function () {
            return this.sellerForm.get('branchCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerDetailComponent.prototype, "branchName", {
        get: function () {
            return this.sellerForm.get('branchName');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerDetailComponent.prototype, "addressTH", {
        get: function () {
            return this.sellerForm.get('addressTH');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerDetailComponent.prototype, "addressEN", {
        get: function () {
            return this.sellerForm.get('addressEN');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerDetailComponent.prototype, "postalCode", {
        get: function () {
            return this.sellerForm.get('postalCode');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SellerDetailComponent.prototype, "previewDetail", {
        get: function () {
            var detail = {
                name_th: this.nameTH.value,
                name_en: this.nameEN.value,
                tax_id: this.taxID.value,
                address_th: this.addressTH.value,
                address_en: this.addressEN.value,
                post_code: this.postalCode.value
            };
            return detail;
        },
        enumerable: true,
        configurable: true
    });
    return SellerDetailComponent;
}());
export { SellerDetailComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller-detail/seller-detail.component.ts.pre-build-optimizer.js